/**
 * Conversational AI assistant — typed client for /api/v1/wa-bot/ask/.
 *
 * Same LLM and tool surface as the Telegram bot. The user is identified
 * by their JWT, so we just POST the question.
 */
import { apiClient } from './axios';

export interface ToolCall {
  name: string;
  arguments: Record<string, unknown>;
  result_summary?: string;
  error?: string;
}

export interface AskResponse {
  reply: string;
  tool_calls: ToolCall[];
  latency_ms: number;
}

export const wabotApi = {
  // AI responses involve a Gemini round-trip + optional retries.
  // Override the global 10s axios timeout with 75s for this endpoint only.
  ask: (question: string) =>
    apiClient.post<AskResponse>('/wa-bot/ask/', { question }, { timeout: 75_000 }),
};
